// extracted by mini-css-extract-plugin
module.exports = {"relateContainer":"_19NcK-_qjOa018EtF6UxsZ","itemContainer":"_2qxGHAz2hoipcMAbggo_5Q","newsTitle":"uaEeWx4OZX8ffGmVhsXyc","newsPic":"_3WHPrjXyGTWAlBg7M_vS6B"};